// GOV-7 Phase 2 — decode a Google "encoded polyline" string into [{lat,lng}] for PRESENTATION ONLY.
// Standard algorithm: https://developers.google.com/maps/documentation/utilities/polylinealgorithm
//
// IMPORTANT: decoding geometry is NOT routing. We render the polyline the BACKEND already computed via
// Google Routes (the ONE server-side route/ETA authority — services/core location_eta_*). The browser
// NEVER calls Directions / Routes / DistanceMatrix and NEVER computes an ETA. This keeps a single route
// authority and creates no provider usage / meter from the map.
export function decodePolyline(encoded, precision = 5) {
  if (typeof encoded !== 'string' || encoded.length === 0) return [];
  const factor = Math.pow(10, precision);
  const points = [];
  const len = encoded.length;
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < len) {
    let result = 0;
    let shift = 0;
    let b;
    do {
      b = encoded.charCodeAt(index++) - 63;
      if (Number.isNaN(b)) return points; // malformed / truncated input → stop safely (never loop forever)
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    lat += result & 1 ? ~(result >> 1) : result >> 1;

    result = 0;
    shift = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      if (Number.isNaN(b)) return points;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    lng += result & 1 ? ~(result >> 1) : result >> 1;

    points.push({ lat: lat / factor, lng: lng / factor });
  }
  return points;
}
